module.exports = __webpack_public_path__ + "img/activity_bj2.3abe9a97.png";